module.exports = __webpack_public_path__ + "static/media/con_nombre.c8e5fd49.png";